export default "__VITE_ASSET__sh91cJCV__"